import type { Product } from "data/data";

/** Some APIs wrap the product as `{ item: { id, name, ... } }`. */
export function normalizeMenuProductRow(row: any): any {
  if (!row || typeof row !== "object") return row;
  if (row.item != null && typeof row.item === "object" && row.item.id != null) {
    return { ...row.item, ...row };
  }
  return row;
}

/**
 * `/onlineOrder/menu` → categories with `items[]`, or a flat product list, or wrapped rows.
 */
export function flattenOnlineMenuItems(categories: any[] | undefined): Product[] {
  if (!categories?.length) return [];
  const looksLikeNestedCategories = categories.some(
    (c: any) => Array.isArray(c?.items)
  );
  const raw: any[] = looksLikeNestedCategories
    ? categories.flatMap((cat: any) => cat?.items ?? [])
    : categories;
  return raw.map(normalizeMenuProductRow) as Product[];
}

/** DFS when flatten misses — search nested `items` before treating a node as a product. */
export function findProductInMenuTree(
  nodes: any[] | undefined,
  targetId: number
): any | null {
  if (!nodes?.length) return null;
  for (const node of nodes) {
    if (!node || typeof node !== "object") continue;
    const items = (node as any).items;
    if (Array.isArray(items) && items.length > 0) {
      const found = findProductInMenuTree(items, targetId);
      if (found) return found;
    }
    const normalized = normalizeMenuProductRow(node);
    if (Number(normalized.id) === Number(targetId)) {
      return normalized;
    }
  }
  return null;
}

export function unwrapMenuResponseBody(data: any): any {
  if (data == null) return data;
  if (typeof data === "object" && data.data != null && data.items == null) {
    return data.data;
  }
  return data;
}
